<template>
  <el-dialog
    :visible.sync="gridContextMenuModalVisible"
    :close-on-click-modal="false"
    @close="gridContextMenuModalHide"
    width="23%"
    v-draggable
  >
    <div ref="gridContextMenu">
      <el-card class="box-card">
        <div slot="header">
          <span style="font-weight: bold;">{{
            $t("gridcontextmenu.gridContextMenuModal.header")
          }}</span>
        </div>
        <div>
          <el-link
            type="primary"
            class="link-item"
            @click="onGridContextMenuClick('full')"
            >{{ $t("gridcontextmenu.gridContextMenuModal.menu.full") }}</el-link
          >
        </div>
        <div>
          <el-link
            type="primary"
            class="link-item"
            @click="onGridContextMenuClick('optimal')"
            >{{
              $t("gridcontextmenu.gridContextMenuModal.menu.optimal")
            }}</el-link
          >
        </div>
        <div>
          <el-link
            type="primary"
            class="link-item"
            @click="onGridContextMenuClick('load')"
            >{{ $t("gridcontextmenu.gridContextMenuModal.menu.load") }}</el-link
          >
        </div>
        <el-divider></el-divider>
        <div>
          <el-link
            type="primary"
            class="link-item"
            @click="onGridContextMenuClick('save')"
            >{{ $t("gridcontextmenu.gridContextMenuModal.menu.save") }}</el-link
          >
        </div>
      </el-card>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { dialogWidth } from "@/mixins/dialogWidth";

export default {
  name: "gridcontextmenu",
  mixins: [dialogWidth],
  data() {
    return {
      gridContextMenuModalVisible: false
    };
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapGetters([
      "gridContextMenuModal",
      "gridContextMenuKey",
      "gridContextMenuEvent"
    ])
  },
  watch: {
    gridContextMenuModal: function(value) {
      this.gridContextMenuModalVisible = value;
    },
    gridContextMenuModalVisible: function(value) {
      this.setGridContextMenuModal(value);
    }
  },
  methods: {
    ...mapMutations([
      "setGridContextMenuModal",
      "setGridContextMenuKey",
      "setGridContextMenuEvent"
    ]),
    gridContextMenuModalHide() {
      this.setGridContextMenuKey("");
      this.setGridContextMenuEvent({});
      this.$refs.gridContextMenu.scrollTo(0, 0);
    },
    onGridContextMenuClick(action) {
      switch (action) {
        case "full":
          const allColumnIds = [];
          this.gridContextMenuEvent.columnApi
            .getAllColumns()
            .forEach(column => {
              allColumnIds.push(column.colId);
            });
          this.gridContextMenuEvent.columnApi.autoSizeColumns(
            allColumnIds,
            false
          );
          break;
        case "optimal":
          this.gridContextMenuEvent.api.sizeColumnsToFit();
          break;
        case "load":
          const stateGridSubscribers = this.$localStorage.get(
            this.gridContextMenuKey
          );

          if (stateGridSubscribers) {
            const gridState = JSON.parse(stateGridSubscribers);
            if (gridState) {
              const status = this.gridContextMenuEvent.columnApi.applyColumnState(
                {
                  state: gridState,
                  applyOrder: true
                }
              );
              if (status) {
                this.gridStateApplied("loadSuccess");
              } else {
                this.gridStateApplied("loadError");
                this.$localStorage.remove(this.gridContextMenuKey);
              }
            }
          } else {
            this.gridStateApplied("loadError");
          }
          break;
        case "save":
          const gridState = this.gridContextMenuEvent.columnApi.getColumnState();
          this.$localStorage.set(
            this.gridContextMenuKey,
            JSON.stringify(gridState)
          );
          this.gridStateApplied("saveSuccess");
          break;
      }

      this.gridContextMenuModalVisible = false;
    },
    gridStateApplied(status) {
      let message, type;

      switch (status) {
        case "loadSuccess":
          message = this.$t(
            "gridcontextmenu.gridContextMenuModal.stateApplied.loadSuccess"
          );
          type = "success";
          break;
        case "saveSuccess":
          message = this.$t(
            "gridcontextmenu.gridContextMenuModal.stateApplied.saveSuccess"
          );
          type = "success";
          break;
        case "loadError":
          message = this.$t(
            "gridcontextmenu.gridContextMenuModal.stateApplied.loadError"
          );
          type = "warning";
          break;
      }

      this.$message({
        showClose: true,
        message,
        type
      });
    }
  }
};
</script>
